import React from 'react';
import './Privacy.css';
import Header from './Header';
import Footer from './Footer';

const Privacy = () => {
    return (
        <>
            <Header />
            <div className="privacy-container">
                <h1 className="privacy-title">Privacy Policy</h1>
                <p className="privacy-intro">
                    At <strong>Digital Journaling</strong>, we respect your privacy and are committed to protecting your personal information. 
                    This Privacy Policy outlines how we collect, use, and safeguard your data when you interact with our website and services.
                </p>

                <section className="privacy-section">
                    <h2 className="privacy-subtitle">1. Information We Collect</h2>
                    <p className="privacy-text">We may collect the following types of information:</p>
                    <ul className="privacy-list">
                        <li><strong>Personal Information:</strong> such as your name, email address, and mobile number when you contact us.</li>
                        <li><strong>Usage Data:</strong> details about how you interact with our website, including IP address, browser type, and pages visited.</li>
                        <li><strong>Cookies:</strong> small data files to enhance your browsing experience and personalize content.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2 className="privacy-subtitle">2. How We Use Your Information</h2>
                    <p className="privacy-text">
                        The information we collect is used to:
                    </p>
                    <ul className="privacy-list">
                        <li>Provide and improve our services.</li>
                        <li>Communicate with you regarding updates, newsletters, or responses to inquiries.</li>
                        <li>Maintain the security and functionality of our platform.</li>
                        <li>Analyze usage trends to enhance user experience.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2 className="privacy-subtitle">3. Sharing Your Information</h2>
                    <p className="privacy-text">
                        We do not sell or rent your personal data. Information may only be shared:
                    </p>
                    <ul className="privacy-list">
                        <li>When required by law, regulation, or legal process.</li>
                        <li>With trusted service providers who assist in operating our platform, under strict confidentiality agreements.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2 className="privacy-subtitle">4. Your Privacy Choices</h2>
                    <p className="privacy-text">
                        You have control over your data. You may:
                    </p>
                    <ul className="privacy-list">
                        <li>Opt-out of promotional communications at any time.</li>
                        <li>Disable cookies in your browser settings.</li>
                        <li>Request access, correction, or deletion of your personal data.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2 className="privacy-subtitle">5. Contact Us</h2>
                    <p className="privacy-text">
                        If you have questions or concerns about our Privacy Policy, please reach out to us at: <br />
                        <a href="/contact" className="privacy-link">Contact Digital Journaling</a>
                    </p>
                </section>
            </div>
            <Footer />
        </>
    );
};

export default Privacy;
